import {Injectable} from '@angular/core';


@Injectable({providedIn: 'root'})
export class RedirectService {
    private _redirectUrl: string | null = null;

    set(redirectUrl: string | null) {
        this._redirectUrl = redirectUrl;
    }

    get redirectUrl(): string | null {
        return this._redirectUrl;
    }
}